export interface IUnlockedContent {
  contentUnlocked: string;
  unitName: string;
  unitDescription?: string;
  category: string;
  isUnlocked: boolean;
}

export class UnlockedContent implements IUnlockedContent {
  contentUnlocked: string;
  unitName: string;
  unitDescription?: string;
  category: string;
  isUnlocked: boolean;
}
